<section class="relative block py-24 lg:pt-0 bg-blueGray-800">
  <div class="container mx-auto px-4">
    <div class="flex flex-wrap justify-center lg:-mt-64 -mt-48">
      <div class="w-full lg:w-6/12 px-4">
        <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200">
          <form name="contact" class="flex-auto p-5 lg:p-10" netlify [formGroup]="contactForm">
            <p class="leading-relaxed mt-1 mb-4 text-blueGray-500">
              Completa este formulario y recibirás noticias nuestras en muy poco tiempo.
            </p>
            <div class="relative w-full mb-3 mt-8">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="full-name">
                Nombre completo
              </label>
              <input type="text" id="name"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Nombre completo" formControlName="fcname" required />
              <div
                *ngIf="contactForm.controls['fcname'].invalid && (contactForm.controls['fcname'].dirty || contactForm.controls['fcname'].touched)"
                class="alert alert-danger">

                <div *ngIf="contactForm.controls['fcname'].errors?.required">
                  El nombre es requerido.
                </div>
              </div>

            </div>

            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="email">
                Correo
              </label>
              <input type="email" name="email"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Correo" formControlName="fcemail" required />
              <div
                *ngIf="contactForm.controls['fcemail'].invalid && (contactForm.controls['fcemail'].dirty || contactForm.controls['fcemail'].touched)"
                class="alert alert-danger">

                <div *ngIf="contactForm.controls['fcemail'].errors?.required">
                  Email es requerido.
                </div>
                <div *ngIf="contactForm.controls['fcemail'].errors?.email">
                  El correo debe ser válido.
                </div>
              </div>
            </div>

            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="message">
                Mensaje
                <span *ngIf="sentiment == 'positive'">😃</span>
                <span *ngIf="sentiment == 'negative'">🙁</span>
                <span *ngIf="sentiment == 'neutral'">😐</span>
              </label>
              
              <textarea rows="4" cols="80" type="text" name="message"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
                placeholder="Escribe aquí el mensaje..." formControlName="fcmessage" required
                (ngModelChange)="onMessageTextChange($event)"></textarea>
              <div
                *ngIf="contactForm.controls['fcmessage'].invalid && (contactForm.controls['fcmessage'].dirty || contactForm.controls['fcmessage'].touched)"
                class="alert alert-danger">

                <div *ngIf="contactForm.controls['fcmessage'].errors?.required">
                  El mensaje es requerido.
                </div>
                <div *ngIf="contactForm.controls['fcmessage'].errors?.minlength || contactForm.controls['fcmessage'].errors?.minLengthString">
                  El mensaje debe tener al menos 10 carácteres.
                </div>
              </div>
            </div>
            <div class="text-center mt-6">
              <button
                class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                [disabled]="contactForm.controls['fcname'].invalid || contactForm.controls['fcemail'].invalid"
                (click)="submitContact()" type="submit">
                Enviar Mensaje
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
